import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {
    CampaignsServiceModuleName,
    ContactProfileModuleName,
    LeadProfileModuleName
} from "../utils/names/optionalModuleNames";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {LeadServiceName} from "../utils/names/serviceNames";
import {LeadProfileController} from "./controller/profile/LeadProfileController";
import {LeadService} from "./service/LeadService";
import {LoaderStatusValue} from "../loader/service/loaderStatus";
import {getTabName} from "modules/utils/TabNameUtils";

function getSelectedLeadResolver() {
    return [
        LeadServiceName,
        '$route',
        'LoaderStatusValue',
        function (leadService: LeadService,
                  $route: ng.route.IRouteService,
                  loader: LoaderStatusValue) {
            loader.on();
            return leadService.fetchContactDetails($route.current.params.leadId)
                .then(lead => {
                    loader.off();
                    return lead;
                });
        }]
}

export const LeadProfileModuleConfiguration = new RestrictedRouteModuleConfiguration(
    LeadProfileModuleName,
    [
        LeadProfileModuleName,
        CampaignsServiceModuleName,
        ContactProfileModuleName
    ],
    [
        ["/lead_profile/:leadId", {
            template: LeadProfileController.template,
            controller: 'leadProfileController',
            resolve: {
                'selectedContact': getSelectedLeadResolver()
            }
        }]
    ],
    [],
    [LeadProfileModuleName],
    [UserGranredAuthorityName.LEADS],
    getTabName() + '| Lead Profile'
);

export default LeadProfileModuleConfiguration;